/* Hound & Trail – product page upgrade (Batch 27): variant pills + size chart popup. Progressive: the native select still works without JS. */
(function(){
  var d=document;
  d.querySelectorAll('[data-vp]').forEach(function(vp){
    var area=vp.closest('.product-details')||d, sel=area.querySelector('[data-variant-select]'); if(!sel) return;
    var vs=[]; try{ vs=JSON.parse(vp.querySelector('[data-vp-variants]').textContent); }catch(e){ return; }
    var groups=[].slice.call(vp.querySelectorAll('[data-vp-group]'));
    var current=function(){ return groups.map(function(g){ var c=g.querySelector('.vp-input:checked'); return c?c.value:null; }); };
    var match=function(o){ for(var i=0;i<vs.length;i++){ var ok=true; for(var j=0;j<o.length;j++){ if(vs[i].o[j]!==o[j]){ ok=false; break; } } if(ok) return vs[i]; } return null; };
    var mark=function(){
      var cur=current();
      groups.forEach(function(g,gi){
        var lab=g.querySelector('[data-vp-current]'); if(lab) lab.textContent=cur[gi]||'';
        g.querySelectorAll('.vp-input').forEach(function(inp){
          var o=cur.slice(); o[gi]=inp.value; var v=match(o);
          var pill=inp.nextElementSibling; pill.classList.toggle('is-unavail', !v || !v.a);
          pill.title = !v ? 'Not available in this combination' : (!v.a ? 'Sold out' : '');
        });
      });
    };
    vp.addEventListener('change', function(e){
      if(!e.target.matches('.vp-input')) return;
      var gi=groups.indexOf(e.target.closest('[data-vp-group]')), cur=current(), v=match(cur);
      if(!v){ // pick the first variant with the value just chosen, then sync the other pills
        for(var i=0;i<vs.length;i++){ if(vs[i].o[gi]===cur[gi]){ v=vs[i]; break; } }
        if(v) groups.forEach(function(g,k){ g.querySelectorAll('.vp-input').forEach(function(inp){ inp.checked = inp.value===v.o[k]; }); });
      }
      if(v && String(sel.value)!==String(v.id)){ sel.value=String(v.id); sel.dispatchEvent(new Event('change',{bubbles:true})); }
      mark();
    });
    mark();
  });
  // Size chart dialog
  var toIn=function(s){ return String(s).replace(/\d+(?:\.\d+)?/g,function(n){ return (Math.round(parseFloat(n)/2.54*10)/10).toFixed(1); }); };
  d.querySelectorAll('[data-sc-open]').forEach(function(btn){
    var dlg=d.getElementById(btn.getAttribute('data-sc-open')); if(!dlg) return;
    if(dlg.parentNode!==d.body) d.body.appendChild(dlg); // keep the dialog out of the product form
    var close=function(){ if(dlg.open) dlg.close(); };
    btn.addEventListener('click', function(){ if(typeof dlg.showModal==='function'){ dlg.showModal(); } else { dlg.setAttribute('open',''); } d.body.classList.add('sc-open'); var x=dlg.querySelector('[data-sc-close]'); if(x) x.focus(); });
    dlg.addEventListener('close', function(){ d.body.classList.remove('sc-open'); btn.focus(); });
    dlg.addEventListener('click', function(e){ if(e.target===dlg) close(); });
    dlg.querySelectorAll('[data-sc-close]').forEach(function(x){ x.addEventListener('click', function(){ if(dlg.close) close(); else { dlg.removeAttribute('open'); d.body.classList.remove('sc-open'); } }); });
    dlg.querySelectorAll('[data-sc-unit]').forEach(function(u){
      u.addEventListener('click', function(){
        var inch=u.getAttribute('data-sc-unit')==='in';
        dlg.querySelectorAll('[data-sc-unit]').forEach(function(b){ b.setAttribute('aria-pressed', String(b===u)); });
        dlg.querySelectorAll('[data-sc-u]').forEach(function(s){ s.textContent=inch?'(in)':'(cm)'; });
        dlg.querySelectorAll('td[data-cm]').forEach(function(td){ var v=td.getAttribute('data-cm'); td.textContent = inch ? toIn(v) : v; });
      });
    });
  });
})();
